import * as Sentry from 'sentry-expo';
import {Platform} from 'react-native';

export let captureException = (exception: any, context: any) => {
  Platform.select({
    web: () => Sentry.Browser.captureException(exception, context),
    default: () => Sentry.Native.captureException(exception, context),
  })();
};
